export const utilityType = {
  search: "SEARCH",
  user: "USER",
  reservation: "RESERVATION",
  template: "TEMPLATE",
  notification: "NOTIFICATION",
};
